<template>
    <div>
        <label
            v-if="label"
            :for="uniqueId"
            class="form-group-label d-flex align-items-center"
        >
            {{ label }}
        </label>

        <editor
            v-if="imagesUploadUrl"
            v-model="inputValue"
            @change="handleChange"
            :id="uniqueId"
            :name="name"
            :api-key="tinyApiKey"
            :init="{
                plugins: ['lists link autolink anchor image code'],
                toolbar: `
                    undo redo | formatselect | bold italic underline | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist | removeformat | image | code
                `,
                images_upload_url: imagesUploadUrl,
            }"
        />

        <editor
            v-else
            v-model="inputValue"
            @change="handleChange"
            :id="uniqueId"
            :name="name"
            :api-key="tinyApiKey"
            :init="{
                plugins: ['lists link autolink anchor code'],
                toolbar: `
                    undo redo | bold italic underline | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist | removeformat | code
                `,
            }"
        />
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue';

    export default {
        name: 'Editor',
        props: {
            value: {
                type: String,
                default: '',
            },
            label: {
                type: String,
                default: '',
            },
            name: {
                required: true,
                type: String,
            },
            imagesUploadUrl: {
                required: String,
                default: '',
            },
        },
        components: {
            editor: Editor,
        },
        data() {
            return {
                tinyApiKey: 'mlpztbdr9nimqa8mbafztkvt848hb5kli7cy50ptdih6qkw8',
                inputValue: '',
            };
        },
        computed: {
            uniqueId() {
                return this.$id('text-input');
            },
        },
        methods: {
            handleChange() {
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.inputValue = value;
                },
            },
        },
    };
</script>
